export const validateBoatReviewForm = (formData) => {
  const errors = {};

  if (!formData.reviewer_name?.trim()) {
    errors.reviewer_name = 'Name is required';
  }

  if (!formData.email?.trim()) {
    errors.email = 'Email is required';
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    errors.email = 'Invalid email format';
  }

  if (!formData.comment?.trim()) {
    errors.comment = 'Comment is required';
  } else if (formData.comment.length > 300) {
    errors.comment = 'Comment cannot exceed 300 characters';
  }

  const rating = formData.rating || 5;
  if (!Number.isInteger(rating) || rating < 1 || rating > 5) {
    errors.rating = 'Rating must be between 1 and 5';
  }

  return errors;
}; 